<template>
  <station-activity-dashboard
    :startDate="startDate"
    :endDate="endDate"
    :stationActivityData="stationActivityData"
    :isLoading="loadingStationActivity"
    @changeRegion="handleChangeRegion"
    @changeDate="handleChangeDate"
    @changePage="handleChangePage">
  </station-activity-dashboard>
</template>

<script>
import { mapState } from 'vuex';
import StationActivityDashboard from '@/components/admin/StationActivityDashboard';
import * as stationactivityTypes from '@/store/modules/stationactivity/mutation-types';

export default {
  name: 'StationActivityContainer',
  components: {
    StationActivityDashboard,
  },

  computed: {
    ...mapState('stationactivity', [
      'region',
      'startDate',
      'endDate',
      'stationActivityData',
      'loadingStationActivity',
    ]),
    ...mapState('user', ['me']),
  },

  mounted() {
    this.$store.commit(`stationactivity/${stationactivityTypes.GET_STATION_ACTIVITY}`);
    this.$store.dispatch('stationactivity/getStationActivity', {
      startDate: this.startDate,
      endDate: this.endDate,
    });
  },

  methods: {
    handleChangeRegion(event) {
      this.$store.commit(
        `stationactivity/${stationactivityTypes.SET_STATION_ACTIVITY_REGION}`,
        event.region,
      );
      this.$store.commit(`stationactivity/${stationactivityTypes.GET_STATION_ACTIVITY}`);
      this.$store.dispatch('stationactivity/getStationActivity');
    },
    handleChangeDate(event) {
      if (this.startDate === event.startDate && this.endDate === event.endDate) return;

      this.$store.commit(
        `stationactivity/${stationactivityTypes.SET_STATION_ACTIVITY_START_DATE}`,
        event.startDate,
      );
      this.$store.commit(
        `stationactivity/${stationactivityTypes.SET_STATION_ACTIVITY_END_DATE}`,
        event.endDate,
      );
      this.$store.commit(`stationactivity/${stationactivityTypes.GET_STATION_ACTIVITY}`);
      this.$store.dispatch('stationactivity/getStationActivity');
    },
    handleChangePage(offset) {
      this.$store.commit(
        `stationactivity/${stationactivityTypes.SET_STATION_ACTIVITY_OFFSET}`,
        offset,
      );
      this.$store.commit(`stationactivity/${stationactivityTypes.GET_STATION_ACTIVITY}`);
      this.$store.dispatch('stationactivity/getStationActivity');
    },
  },
};
</script>


// WEBPACK FOOTER //
// StationActivityContainer.vue?48b1b35f